import { Outlet, useLocation } from 'react-router-dom';

import { GlobalCatch } from '@/components/common/GlobalCatch';
import { Menu } from '@/components/menu/Menu';
import { PageFooter } from '@/components/PageFooter/PageFooter';
import { useAuth } from '@/context/AuthProvider';
import { NavigationGuardProvider } from '@/context/NavigationGuardProvider';
import { Modals } from '@/router';

import './styles.scss';

import { FaqSection } from '@/components/FaqSection/FaqSection';
import { useFaq } from '@/components/FaqSection/useFaq';

function footerIsShown(pathname: string): boolean {
  return (
    !pathname.includes('liSettings') &&
    !pathname.includes('ioSettings') &&
    !pathname.includes('reporting') &&
    !pathname.includes('contextSystem')
  );
}

export const Catch = () => {
  return <GlobalCatch />;
};

export default function App() {
  const { pathname } = useLocation();
  const { status } = useAuth();
  const { showFaq, openFaq, closeFaq } = useFaq();
  const showFooter = footerIsShown(pathname);

  return status === 'authenticated' ? (
    <NavigationGuardProvider>
      <header className="platform-header">
        <Menu />
      </header>
      <main>{showFaq ? <FaqSection onClose={closeFaq} /> : <Outlet />}</main>
      {showFooter && (
        <footer className="platform-footer">
          <PageFooter onFaqOpen={openFaq} variant="light" />
        </footer>
      )}
      <Modals id="global" />
    </NavigationGuardProvider>
  ) : null;
}
